import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withGameAutoplayComponentConfiguration from "./configuration/withgameAutoplayComponentConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
//import { Scrollbox } from 'pixi-scrollbox'
import { actions as autoplayKeyboardListenerAction } from "../../gamereducer/autoplayKeyboardListenerReducer";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";

interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class GameAutoplayComponent extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected gameAutoplayComponent: any;
    protected gameAutoplayComponentContainer: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameAutoplayComponentList: Array<any>
    private singlewinlimit: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.gameAutoplayComponent = React.createRef();
        this.gameAutoplayComponentContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.gameAutoplayComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
        this.addScrollBar();
    }

    addScrollBar() {
        let gameAutoplayContent: any = UIManager.getRef("gameAutoplayContent")
        let gameAutoplayScrollComponent: any = UIManager.getRef("gameAutoplayScrollComponent")
        let rulesHeading: any = UIManager.getRef("Rules_Heading")
        const Scrollbox = require('pixi-scrollbox').Scrollbox
        let boxWith, boxHeight;
        if (isMobile) {
            boxWith = 1155;

        }
        else {
            boxWith = 800;

        }
        const scrollbox = new Scrollbox({ boxWidth: boxWith, boxHeight: 700 })

        scrollbox.x = 550;
        scrollbox.y = 200;
        gameAutoplayScrollComponent && gameAutoplayScrollComponent.addChild(scrollbox)
        // add a sprite to the scrollbox's content
        const sprite = scrollbox.content.addChild(new PIXI.Sprite(PIXI.Texture.WHITE))
        sprite.width = boxWith
        sprite.height = 700
        isMobile && (sprite.alpha = 0.01);
        sprite.tint = 0x131313
        scrollbox.content.addChild(gameAutoplayContent);
        // force an update of the scrollbox's calculations after updating the children
        // add the viewport to the stage
        scrollbox.update()
    }
    stopOnAnyWinOption() {
        this.props.stoppedAutoplayOnWin();
    }

    stopOnFeatureTriggered() {
        this.props.stoppedAutoplayOnFreeGame();
    }

    radioController(currentToggleState: any, nextToggleState: any) {
        UIManager.getRef(currentToggleState) && (UIManager.getRef(currentToggleState).visible = false);
        UIManager.getRef(currentToggleState) && (UIManager.getRef(nextToggleState).visible = true);
    }

    handleEvent = (e: any) => {

        switch (e.target.name) {

            case "stopOnAnyWin_disable":
                this.stopOnAnyWinOption()
                this.radioController("stopOnAnyWin_disable", "stopOnAnyWin_enable");
                return;
            case "stopOnAnyWin_enable":
                this.radioController("stopOnAnyWin_enable", "stopOnAnyWin_disable");
                return;
            case "stopfeaturetriggered_disable":
                this.stopOnFeatureTriggered();
                this.radioController("stopfeaturetriggered_disable", "stopfeaturetriggered_enable");
                return;
            case "stopfeaturetriggered_enable":
                this.radioController("stopfeaturetriggered_enable", "stopfeaturetriggered_disable");
                return;
            default:
                return 'No buttons';
        }
    }

    componentDidMount() {
        this.bindUI();

        //  this.addListenersToTextFields();
        //  this.addInputTextFieldToContainers();
    }

    addInputTextFieldToContainers() {
        let lossLimitContainer = UIManager.getRef("lossLimitContainer");
        if (lossLimitContainer) {
            this.addTextInputFields(lossLimitContainer, 1166, 305);
        }

        let winLimitContainer = UIManager.getRef("winLimitContainer");
        if (winLimitContainer) {
            this.addTextInputFields(winLimitContainer, 1166, 305);
        }

        let singleWinLimitContainer = UIManager.getRef("singlewinlimitContainer");
        if (singleWinLimitContainer) {
            this.addTextInputFields(singleWinLimitContainer, 1166, 305);
        }
    }

    addTextInputFields(parent: any, XPos: any, Ypos: any) {
        const TextInput = require('pixi-text-input')
        let inputTxtField = new TextInput({
            input: {
                fontFamily: 'Arial',
                fontSize: '20px',
                padding: '14px 24px',
                width: '126px',
                color: 'black',
                height: '32px'
            },
            box: this.generateBox
        })

        //inputTxtField.placeholder = 'Enter your Text...'
        inputTxtField.name = parent.name + "_text_field"
        inputTxtField.x = XPos
        inputTxtField.y = Ypos
        var reg = /^\d+$/;
        inputTxtField.restrict = reg;

        let parentContainer = parent
        if (parentContainer) {
            parentContainer.addChild(inputTxtField)
            inputTxtField.on('keydown', (keycode: any) => {
                if (Number(inputTxtField.text) > this.props.coinList[this.props.selectedCoin] * 50) {

                }
            })

            inputTxtField.on('focus', (keycode: any) => {
                this.disableSelectedButton(parentContainer.name)

            })
            inputTxtField.on('blur', (keycode: any) => {
                //Number(inputTxtField.text).toFixed(2)
                this.setLimitOnFocusOut(parentContainer.name, Number(inputTxtField.text));

            })
        }
    }

    generateBox(w: any, h: any, state: any) {
        var box = new PIXI.Container()
        var sprite = UIManager.getRef('nummShellTxtField')
        var mask = new PIXI.Graphics()
        mask.beginFill(0xFFFFFF)
        mask.drawRoundedRect(0, 0, w, h, 50)
        box.addChild(mask)
        if (sprite) {
            box.addChild(sprite)
            sprite.mask = mask

            switch (state) {
                case 'DEFAULT':
                    sprite.tint = 0xffffff
                    break;
                case 'FOCUSED':
                    sprite.tint = 0x7EDFFF
                    break;
                case 'DISABLED':
                    sprite.alpha = 0.5
                    break;
            }
        }

        return box
    }

    disableSelectedButton(parentName: any) {
        switch (parentName) {
            case 'winLimitContainer':

                this.props.setBalanceIncreasedBy(0);
                break;
            case 'singlewinlimitContainer':


                this.props.setSingleWinExceed(0);
                break;
            case 'lossLimitContainer':

                this.props.setBalanceDecreasedBy(0);
                break;
        }

    }

    setLimitOnFocusOut(parentName: any, value: any) {
        if (value > 0) {
            switch (parentName) {
                case 'winLimitContainer':
                    UIManager.getRef('winLimitContainer').getChildByName("winLimitContainer_text_field").text = value.toFixed(2)
                    this.props.setBalanceIncreasedBy(value);
                    break;
                case 'singlewinlimitContainer':
                    UIManager.getRef('singlewinlimitContainer').getChildByName("singlewinlimitContainer_text_field").text = value.toFixed(2)
                    this.props.setSingleWinExceed(value);
                    break;
                case 'lossLimitContainer':
                    UIManager.getRef('lossLimitContainer').getChildByName("lossLimitContainer_text_field").text = value.toFixed(2)
                    this.props.setBalanceDecreasedBy(value);
                    break;
            }
        }

    }



    addListenersToTextFields() {
        /*    this.singlewinlimit = UIManager.getRef("singlewinlimit_disable");
           this.singlewinlimit.interactive = true;
           this.singlewinlimit.click = (event: any) => {
   
           } */
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }
    render() {

        return (<UIManager id={"gameAutoplayComponent"} name={"gameAutoplayComponent"} type={"Container"}
            ref={i => this.gameAutoplayComponent = i}
            x={0} y={0}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} ClickHandler={this.handleEvent} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'betPanelState'>): IStateToProps =>
    ({
        coinList: state.betPanelState.coinList,
        selectedCoin: state.betPanelState.selectedCoin,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAutoplayKeyboardListenerActive: (autoplayKeyboardListenerActive: boolean): any => dispatch(autoplayKeyboardListenerAction.setAutoplayKeyboardListenerActive(autoplayKeyboardListenerActive)),
        stoppedAutoplayOnWin: (): any => dispatch(autoplayActions.stoppedAutoplayOnWin()),
        stoppedAutoplayOnFreeGame: (): any => dispatch(autoplayActions.stoppedAutoplayOnFreeGame()),
        setBalanceIncreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceIncreasedBy(value)),
        setBalanceDecreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceDecreasedBy(value)),
        setSingleWinExceed: (value: any): any => dispatch(autoplayActions.setSingleWinExceed(value)),
    }))(withGameAutoplayComponentConfiguration(GameAutoplayComponent)));